export function validationErrorMessage(errors = {}) {
  return Object.values(errors).flat().join(" ")
}

export function saveStatusMessage(alreadySaved = false, updated = false) {
  if (updated) return "Mapping updated successfully."

  return alreadySaved ? "Mapping already saved." : "Mapping saved successfully."
}
